/**
 * @deprecated This file is kept for backward compatibility only.
 * All course data should be fetched from the database via UnifiedCourseService.
 * DO NOT ADD NEW COURSES HERE - use database migrations instead.
 */
import { AWSCourse } from './types';
import { AWS_FUNDAMENTALS_MODULES } from './modules/fundamentals';
import { ENHANCED_AWS_FUNDAMENTALS_MODULES } from './modules/enhanced-fundamentals';
import { AWS_ASSOCIATE_MODULES } from './modules/associate';
import { AWS_ADVANCED_MODULES } from './modules/advanced';

export const AWS_COURSES: AWSCourse[] = [
  {
    id: 'aws-fundamentals',
    title: 'AWS Cloud Fundamentals',
    description: 'Master the fundamentals of cloud computing and AWS core services. Perfect for beginners starting their cloud journey with hands-on labs and real-world examples.',
    level: 'Beginner',
    modules: ENHANCED_AWS_FUNDAMENTALS_MODULES,
    totalDuration: '6 hours',
    image: '/api/placeholder/400/300',
    tags: ['Cloud Computing', 'AWS Basics', 'Infrastructure', 'Beginner'],
    prerequisites: ['Basic understanding of web technologies', 'Command line familiarity helpful but not required'],
    learningOutcomes: [
      'Understand cloud computing concepts and the AWS Well-Architected Framework',
      'Navigate the AWS Management Console and configure billing alerts',
      'Deploy and manage EC2 instances with proper security configurations',
      'Store and retrieve data using S3 with lifecycle policies and versioning',
      'Set up RDS databases with automated backups and multi-AZ deployments',
      'Configure VPC networking with subnets, route tables, and security groups',
      'Implement IAM users, groups, policies, and roles following security best practices',
      'Monitor resources using CloudWatch and set up automated alarms',
      'Estimate and optimize AWS costs using cost management tools'
    ],
    estimatedHours: 6,
    objectives: [
      'Build foundational knowledge of cloud computing and AWS global infrastructure',
      'Gain hands-on experience with essential AWS services through practical labs',
      'Develop cloud security awareness and implement security best practices',
      'Understand AWS pricing models and implement cost optimization strategies',
      'Prepare for entry-level cloud roles and AWS Cloud Practitioner certification'
    ],
    badge: 'AWS Cloud Practitioner Foundation'
  },
  {
    id: 'aws-associate',
    title: 'AWS Solutions Architect Associate',
    description: 'Design and deploy scalable, highly available systems on AWS. Aligned with the AWS Certified Solutions Architect Associate certification.',
    level: 'Intermediate',
    modules: AWS_ASSOCIATE_MODULES,
    totalDuration: '12 hours',
    image: '/api/placeholder/400/300',
    tags: ['Solutions Architecture', 'Auto Scaling', 'Load Balancing', 'Database Design'],
    prerequisites: ['Basic cloud computing knowledge', 'Familiarity with networking concepts'],
    learningOutcomes: [
      'Design resilient architectures using multiple AWS services',
      'Implement high availability and fault tolerance patterns',
      'Configure Auto Scaling and Load Balancing for optimal performance',
      'Design secure, scalable storage and database solutions',
      'Monitor and troubleshoot AWS infrastructure'
    ],
    estimatedHours: 12,
    objectives: [
      'Master intermediate AWS services and integration patterns',
      'Design cost-effective, scalable architectures',
      'Implement security best practices',
      'Prepare for AWS Solutions Architect Associate certification'
    ],
    badge: 'AWS Solutions Architect Associate Ready'
  },
  {
    id: 'aws-advanced',
    title: 'AWS Advanced Architecture & DevOps',
    description: 'Master advanced AWS patterns including microservices, serverless, and enterprise-scale architectures. For experienced cloud professionals.',
    level: 'Advanced',
    modules: AWS_ADVANCED_MODULES,
    totalDuration: '16 hours',
    image: '/api/placeholder/400/300',
    tags: ['Microservices', 'Serverless', 'DevOps', 'Advanced Architecture'],
    prerequisites: [
      'AWS Solutions Architect Associate level knowledge',
      'Experience with containerization (Docker)',
      'Understanding of CI/CD concepts',
      'Familiarity with programming (Python, Node.js, or Java)'
    ],
    learningOutcomes: [
      'Design and implement microservices architectures',
      'Build serverless applications with Lambda and API Gateway',
      'Implement CI/CD pipelines using AWS DevOps services',
      'Design multi-region, highly available systems',
      'Apply advanced security and compliance patterns'
    ],
    estimatedHours: 16,
    objectives: [
      'Master advanced AWS architectural patterns',
      'Implement DevOps practices on AWS',
      'Design enterprise-scale, resilient systems',
      'Prepare for AWS Professional certifications'
    ],
    badge: 'AWS Advanced Architect'
  }
];
